import { render, staticRenderFns } from "./RecipeHeader.vue?vue&type=template&id=f46d7c34&"
import script from "./RecipeHeader.vue?vue&type=script&lang=ts&"
export * from "./RecipeHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports